function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShipmentsBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.5 20.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1 copy 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.94,9,15.38,5.55H12v7.69H11.1V4.7H0v9.39H1.79a2.14,2.14,0,0,0,4.19,0h8.58a2.14,2.14,0,0,0,4.19,0H20.5V9.82Zm-14,6a1.28,1.28,0,1,1,1.28-1.28A1.28,1.28,0,0,1,3.89,15Zm9.78-6V7.26h1.92L16.87,9Zm3,6a1.28,1.28,0,1,1,1.28-1.28A1.28,1.28,0,0,1,16.66,15Z",
    style: {
      fill: "#1c6f97"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShipmentsBlue);
export default __webpack_public_path__ + "static/media/icon_shipments_blue.22e7ebb84dc0220be5a4e64f99b68554.svg";
export { ForwardRef as ReactComponent };